module.exports = __webpack_public_path__ + "img/loan-time.26177a4e.svg";